import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const LoginRoute = () => {
  let isLoggedIn = useSelector((store) => store.appState.isLoggedIn || false);
  return isLoggedIn === false ? <Outlet /> : <Navigate to="/area" />;
};

export default LoginRoute;
